module.exports = __webpack_public_path__ + "img/6.979db9bf.jpg";